module["exports"] = [
  "??# #??",
  "??## #??",
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/en_GB/address/postcode.js
 ** module id = 403
 ** module chunks = 0
 **/